import { useQuery } from '@tanstack/react-query';
import {
  guideBookingsApi,
  guideBookingsKeys,
  type GuideBookingListParams,
} from '@/features/guide/api/guide-bookings.api';
import { useRefetchAtContactUnlock } from '@/features/booking/hooks/useRefetchAtContactUnlock';

export function useGuideBookings(params?: GuideBookingListParams) {
  return useQuery({
    queryKey: guideBookingsKeys.list(params),
    queryFn: () => guideBookingsApi.list(params),
  });
}

export function useGuideBooking(id: string | null) {
  const query = useQuery({
    queryKey: guideBookingsKeys.detail(id ?? ''),
    queryFn: () => guideBookingsApi.getById(id!),
    enabled: Boolean(id),
  });
  useRefetchAtContactUnlock(query.data ? [query.data] : undefined, query.refetch, query.dataUpdatedAt);
  return query;
}
